export default "__VITE_ASSET__8572425a__"